
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function isProd() {
  return !!window?.env && window.env.environment === 'production';
}

export default function RouteAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!isProd()) return;

    const page_path = location.pathname + location.search + location.hash;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_path,
      page_title: document.title,
      page_location: window.location.href,
      env: window.env?.environment ?? 'production',
    });
  }, [location]);

  return null;
}
